<template>
	<div class="logistics-query">
		<!-- Hero Banner 区域 -->
		<div class="hero-section">
			<div class="hero-bg">
				<el-image :src="heroBg" class="hero-img"></el-image>
			</div>
			<!-- 页面标题描述 -->
			<div class="hero-intro">
				<el-image :src="introIcon" class="intro-icon"></el-image>
				<p class="intro-text">{{$t('indexSeach.t1')}}</p>
			</div>
		</div>

		<!-- 查询区域 -->
		<div class="query-section wow animate__fadeInUp" data-wow-duration="0.8s">
			<div class="query-card">
				<div class="query-inner">
					<!-- 运单输入框 -->
					<div class="query-input-wrap">
						<el-input
							v-model="trackingNumber"
							class="query-input"
							:placeholder="$t('indexSeach.t2')"
							clearable
						></el-input>
					</div>
					<!-- 查询按钮 -->
					<div class="query-btn" @click="handleQuery">{{$t('indexSeach.t3')}}</div>
				</div>
			</div>
		</div>
		
		<!-- 物流信息展示区域 -->
		<div class="result-section animate__animated animate__fadeInUp" data-wow-duration="0.6s">
			
			<div class="result-card" v-if="isshowZw">
				
				<div class="zwBox" v-if="(!goodsList.length)&&isshowZw">
					<el-image :src="require('@/static/zw.svg')"></el-image>
					<p>{{$t('indexSeach.t4')}}</p>
				</div>
				
				<div v-for="(item,index) in goodsList">
					<!-- 路由信息栏 -->
					<div class="route-bar">
						<!-- 始发地 -->
						<div class="route-point origin-point">
							<div class="addrTxt">
								<div class="point-icon-wrap">
									<el-image :src="iconOrigin" class="point-icon"></el-image>
									<span class="point-badge">{{$t('indexSeach.t13')}}</span>
								</div>
								<span class="point-name">{{item.warehouseName}}</span>
							</div>
							<span class="point-label">{{$t('indexSeach.t5')}}</span>
						</div>
						<!-- 箭头 -->
						<el-image :src="iconArrow" class="route-arrow"></el-image>
						<!-- 目的地 -->
						<div class="route-point dest-point">
							<div class="addrTxt">
								<div class="point-icon-wrap">
									<el-image :src="iconDest" class="point-icon"></el-image>
									<span class="point-badge">{{$t('indexSeach.t14')}}</span>
								</div>
								<span class="point-name">{{item.countryName}}</span>
							</div>
							<span class="point-label">{{$t('indexSeach.t6')}}</span>
						</div>
						<!-- 入仓号 -->
						<div class="warehouse-code">
							<span>{{$t('indexSeach.t7')}}：{{item.warehouseNumber}}</span>
						</div>
						<!-- 复制按钮 -->
						<div class="copy-btn" @click="handleCopy(item.warehouseNumber)">
							<el-image :src="iconCopy" class="copy-icon"></el-image>
						</div>
					</div>
					
					<!-- 当前轨迹状态栏 -->
					<div class="status-bar">
						<span class="status-text">{{$t('indexSeach.t8')}}：{{item.transportOrderTrackingList[0].name}}({{item.transportOrderTrackingList[0].createTime}})</span>
						<div class="collapse-btn" @click="opF(item,index)">
							<span>{{ item.isop ? $t('indexSeach.t9') : $t('indexSeach.t10') }}</span>
							<el-image :src="iconCollapse" class="collapse-icon" :class="{ rotated: !item.isop }"></el-image>
						</div>
					</div>
					
					<!-- 物流时间线 -->
					<transition name="timeline-fade">
						
						<div v-show="item.isop" class="timeline-section">
							<!-- 各个节点 -->
							<div
							v-for="(itm, idx) in item.transportOrderTrackingList"
							:key="idx"
							class="timeline-item"
							:class="{ active: idx === 0 }">
								<!-- 节点图标 -->
								<div class="node-icon-wrap">
									<el-image :src="require('@/static/CodeBuddyAssets/31134_1442/11.svg')" class="node-icon"></el-image>
								</div>
								<!-- 节点文字 -->
								<div class="node-info">
									<span class="node-status" :class="{ active: idx === 0 }">{{ itm.name }}</span>
									<span class="node-time" :class="{ active: idx === 0 }">{{ itm.createTime }}</span>
								</div>
								<!-- 垂直连接线 -->
								<div v-if="idx < item.transportOrderTrackingList.length - 1" class="timeline-line-v"></div>
							</div>
						</div>
						
					</transition>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import {
	transportOrderlogisticsChange,
} from "/src/api/api.js"
export default {
	name: 'LogisticsQuery',
	data() {
		return {
			isshowZw:false,
			// 资源路径
			heroBg: require('@/static/CodeBuddyAssets/31134_1442/16.png'),
			introIcon: require('@/static/CodeBuddyAssets/31134_1442/9.svg'),
			iconOrigin: require('@/static/CodeBuddyAssets/31134_1442/5.svg'),
			iconDest: require('@/static/CodeBuddyAssets/31134_1442/6.svg'),
			iconArrow: require('@/static/CodeBuddyAssets/31134_1442/7.svg'),
			iconCopy: require('@/static/CodeBuddyAssets/31134_1442/8.svg'),
			iconCollapse: require('@/static/CodeBuddyAssets/31134_1442/14.svg'),
			// 表单数据
			trackingNumber: '',
			// 数据
			goodsList:[],
		}
	},
	mounted() {
		
	},
	methods: {
		// 执行查询操作
		async handleQuery() {
			if (!this.trackingNumber) {
				this.$message.warning(this.$t('indexSeach.t11'))
				return
			}
			var res;
			res = await transportOrderlogisticsChange({
				orderSn:this.trackingNumber,
			});
			if(res.code==200){
				this.isshowZw = true
				res.rows.forEach((item)=>{
					item.isop = true
				})
				this.goodsList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 复制入仓号
		handleCopy(text) {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success(this.$t('indexSeach.t12'))
				})
			} else {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success(this.$t('indexSeach.t12'))
			}
		},
		// 切换时间线的展开/收缩
		opF(item,index){
			item.isop = !item.isop
			this.$set(this.goodsList,index,item)
		},
		// 页面滚动到顶部
		scrollToTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		}
	}
}
</script>

<style lang="scss" scoped>
.logistics-query {
	position: relative;
	width: 100%;
	background: #F8F8F8;
	padding-bottom: 2rem;
}

/* ===== Hero Banner 区域 ===== */
.hero-section {
	position: relative;
	width: 100%;
	height: 4.00rem;
	.hero-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #0096FF;
		overflow: hidden;
		.hero-img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	.hero-intro {
		position: absolute;
		top: 1.18rem;
		left: 50%;
		transform: translateX(-50%);
		// display: flex;
		// align-items: center;
		gap: 0.20rem;
		width: 14.60rem;
		.intro-icon {
			width: 2.56rem;
			height: 0.54rem;
			display: block;
			margin: auto;
			margin-bottom: 24px;
		}
		.intro-text {
			width: 10.80rem;
			font-size: 0.20rem;
			font-weight: 500;
			text-align: center;
			margin: auto;
			color: #fff;
			line-height: 1.6;
		}
	}
}

/* ===== 查询输入区 ===== */
.query-section {
	width: 14.60rem;
	margin: -0.65rem auto 0;
	position: relative;
	z-index: 10;
}
.query-card {
	background: #fff;
	box-shadow: 0 0.02rem 0.16rem rgba(0, 0, 0, 0.05);
	border-radius: 0.08rem;
	padding: 0.32rem 0.24rem;
}
.query-inner {
	display: flex;
	align-items: center;
	gap: 0.24rem;
}
.query-input-wrap {
	flex: 1;
	min-width: 0;
	.query-input {
		width: 100%;
		::v-deep .el-input__inner {
			height: 0.70rem;
			border: 0.01rem solid #E2E6E9;
			border-radius: 0.05rem;
			font-size: 0.16rem;
			color: #333;
			padding: 0 0.30rem;
			transition: border-color 0.3s, box-shadow 0.3s;
			&::placeholder {
				color: #BFC6CE;
				font-weight: 400;
			}
			&:focus {
				border-color: #0096FF;
				box-shadow: 0 0 0.02rem rgba(0,150,255,0.15);
			}
		}
	}
}
.query-btn {
	width: 2.03rem;
	height: 0.70rem;
	background: #0096FF;
	border-radius: 0.05rem;
	color: #fff;
	font-size: 0.18rem;
	font-weight: 500;
	text-align: center;
	line-height: 0.70rem;
	cursor: pointer;
	flex-shrink: 0;
}

/* ===== 物流结果展示区 ===== */
.result-section {
	width: 14.60rem;
	margin: 0.32rem auto 0;
}
.result-card {
	background: #fff;
	border-radius: 0.08rem;
	padding: 0.32rem 0.28rem;
	padding-bottom: 20px;
}

/* --- 路由信息栏 --- */
.route-bar {
	display: flex;
	align-items: center;
	background: #f6fafe;
	border-radius: 0.08rem;
	padding: 0.32rem 0.22rem;
	position: relative;
}
.route-point {
	gap: 0.04rem;
	.addrTxt{
		display: flex;
		align-items: flex-end;
		.point-icon-wrap {
			position: relative;
			width: 0.20rem;
			height: 0.20rem;
			margin-right: 10px;
			.point-icon {
				width: 100%;
				height: 100%;
			}
			.point-badge {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				font-size: 0.10rem;
				color: #fff;
				font-weight: 400;
			}
		}
		.point-name {
			font-size: 0.16rem;
			font-weight: 500;
			color: #333;
			margin-right: 10px;
		}
		.point-country {
			font-size: 0.14rem;
			color: #9CA4BA;
			font-weight: 500;
		}
	}
	.point-label {
		font-size: 0.14rem;
		display: block;
		color: #9A9C9A;
		font-weight: 400;
		padding-left: 0.28rem;
		margin-top: 0.08rem;
	}
}
.route-arrow {
	width: 0.36rem;
	height: 0.26rem;
	margin: 0 0.40rem;
	flex-shrink: 0;
}
.warehouse-code {
	flex: 1;
	text-align: right;
	font-size: 0.16rem;
	font-weight: 500;
	color: #333;
	margin-right: 0.16rem;
}
.copy-btn {
	cursor: pointer;
	flex-shrink: 0;
	.copy-icon {
		width: 0.22rem;
		height: 0.22rem;
		transition: opacity 0.3s;
	}
	&:hover .copy-icon {
		opacity: 0.65;
	}
}

/* --- 当前轨迹状态栏 --- */
.status-bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	// height: 0.44rem;
	padding: 0.18rem 0.18rem;
	// margin-top: 0.18rem;
	border-bottom: 1px solid #E1E1E1;
	.status-text {
		font-size: 0.14rem;
		font-weight: 400;
		color: #333;
	}
	.collapse-btn {
		display: flex;
		align-items: center;
		cursor: pointer;
		font-size: 0.14rem;
		font-weight: 400;
		color: #0096FF;
		gap: 0.04rem;
		transition: opacity 0.3s;
		.collapse-icon {
			width: 0.14rem;
			height: 0.14rem;
			transition: transform 0.3s ease;
			&.rotated {
				transform: rotate(-180deg);
			}
		}
		&:hover {
			opacity: 0.75;
		}
	}
}

/* --- 物流时间线 --- */
.timeline-section {
	position: relative;
	padding: 0.32rem 0.18rem 0;
}
.timeline-line-h {
	position: absolute;
	left: 0.42rem;
	top: 0.52rem;
	width: 0.01rem;
	height: 2.70rem;
	background: #E1E1E1;
}
.timeline-item {
	display: flex;
	align-items: flex-start;
	gap: 0.16rem;
	position: relative;
	padding-bottom: 0.42rem;
	&:last-child {
		margin-bottom: 0;
	}
	.node-icon-wrap {
		width: 0.28rem;
		height: 0.28rem;
		position: relative;
		display: flex;
		align-items: center;
		border-radius: 50%;
		background: #fff;
		z-index: 1;
		.node-icon {
			width: 0.10rem;
			height: 0.10rem;
			
		}
	}
	.node-info {
		display: flex;
		flex-direction: column;
		gap: 0.06rem;
		.node-status {
			font-size: 0.16rem;
			font-weight: 500;
			color: #999999;
			transition: color 0.3s;
			&.active {
				color: #0096FF;
			}
		}
		.node-time {
			font-size: 0.13rem;
			font-weight: 400;
			color: #999999;
			transition: color 0.3s;
			&.active {
				color: #333333;
			}
		}
	}
	.timeline-line-v {
		position: absolute;
		left: 0.05rem;
		bottom: -0.05rem;
		width: 0.01rem;
		height: 100%;
		background: #E1E1E1;
	}
}

/* ========== 时间线折叠动效 ========== */
.timeline-fade-enter-active,
.timeline-fade-leave-active {
	transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
	transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
	transform-origin: top center;
}
.timeline-fade-enter,
.timeline-fade-leave-to {
	opacity: 0;
	transform: scaleY(0.95) translateY(-0.10rem);
}
/* 减少动态偏好 */
@media (prefers-reduced-motion: reduce) {
	.timeline-fade-enter-active,
	.timeline-fade-leave-active {
		transition: none;
	}
	.timeline-fade-enter,
	.timeline-fade-leave-to {
		opacity: 1;
		transform: none;
	}
}
</style>
